<template>
    <site-img
        v-if="testimonials.length"
        class="md-testimonial layout7 mg-bg"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgType == 'color' ? bgColor : null,
            '--background-attachment': backgroundAttachment
        }"
    >
        <div
            class="reviews-img-mask"
            v-if="bgType == 'img' && maskOption.showMask"
            :style="{
                backgroundColor: maskOption.maskColor
            }"
        ></div>
        <div class="reviews-container">
            <site-title
                class="review-title f-col"
                :title="title"
                :align="align"
            />
            <div
                class="reviews-wrap"
                :class="{ mobile: isMobileSize, only: mobilePerView === 1 }"
            >
                <swiper
                    v-bind="layout7SwiperOptions"
                    :class="{
                        noMargin: testimonials?.length <= 2 && !isMobileSize,
                        'swiper-offset': !isMobileSize && !closeLoop
                    }"
                >
                    <slide
                        v-for="(item, index) in loopTestimonials"
                        :key="index"
                        :style="{ background: agentBgColor }"
                    >
                        <img
                            v-if="item.rmaTrackPixelUrl"
                            class="rma-pixel-img"
                            :src="item.rmaTrackPixelUrl"
                            alt=""
                            loading="lazy"
                        />
                        <div
                            class="item"
                            @click="toViewMore(item)"
                        >
                            <div class="agent-info">
                                <div class="agent-avatar">
                                    <site-img
                                        v-if="item.avatarLink"
                                        class="avatar"
                                        :src="item.avatarLink"
                                        dir="height"
                                    />
                                    <span class="avatar-icon" v-else>
                                        <i class="iconfont icon-people_02"></i>
                                    </span>
                                </div>
                                <div class="agent-name">
                                    <p
                                        class="name"
                                        v-if="item.reviewerName"
                                        v-html="item.reviewerName"
                                    ></p>
                                    <p
                                        class="license"
                                        v-if="item.transactionInfo"
                                        v-html="item.transactionInfo"
                                    ></p>
                                </div>
                            </div>
                            <div class="desc" v-html="item.reviewContent"></div>
                            <div class="start-box">
                                <ReviewScore
                                    :onlyShowActiveScore="true"
                                    :sourceType="item.sourceType"
                                    :score="item.reviewRate"
                                    :iconSize="16"
                                    :iconSpace="5"
                                    :iconName="'icon-Star'"
                                />
                                <ReviewSourceLogo
                                    :sourceType="item.sourceType"
                                    :height="20"
                                />
                            </div>
                        </div>
                    </slide>
                </swiper>
                <div class="swiper-button-wrap" v-if="showSwiperBtn">
                    <button class="swiper-button prevbutton" @click="onPrev">
                        <i class="iconfont icon-arrow_06_left"></i>
                    </button>
                    <button
                        class="swiper-button nextbutton"
                        @click="onNext"
                    >
                        <i class="iconfont icon-arrow_06_right"></i>
                    </button>
                </div>
            </div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </site-img>
</template>
<script>
import common from '../index';
import mixinSlide from '../mixin-slide';
export default {
    mixins: [common, mixinSlide],
    data() {
        return {
            backgroundAttachmentFixed: true,
            activeIndex: 1,
            pcPerView: 2.6,
            align: 'left'
        };
    },
    computed: {
        showSwiperBtn() {
            return this.testimonials?.length > 2;
        },
        reviewWrapperImg() {
            return 'https://cdn.chime.me/image/fs/sitebuild/2024528/6/original_36602caa-c053-4ce9-91e8-fb8ee24e65c3.png';
        },
        mobilePerView({ testimonials }) {
            if (testimonials.length === 1) {
                return 1; 
            }
            return 1.3;
        },
        closeLoop({ isMobileSize, mobilePerView, pcPerView, testimonials }) {
            let perView = isMobileSize ? mobilePerView : pcPerView;
            return testimonials.length < perView;
        },

        layout7SwiperOptions({
            isMobileSize,
            pcPerView,
            mobilePerView,
            closeLoop
        }) {
            let options = {
                ...this.options,
                spaceBetween: isMobileSize ? 10 : 50,
                slidesPerView: isMobileSize ? 'auto' : pcPerView,
                centeredSlides: isMobileSize ? false : true,
                slidesPerGroup: 1,
                initialSlide: isMobileSize ? 0 : closeLoop ? 0 : -1,
                loop: !closeLoop
            };
            return options;
        },
        backgroundAttachment() {
            return this.backgroundAttachmentFixed ? 'fixed' : 'initial';
        },
        loopTestimonials({
            isMobileSize,
            mobilePerView,
            pcPerView,
            testimonials
        }) {
            let perView = isMobileSize ? mobilePerView : pcPerView;
            let len = testimonials.length;
            if (len > perView && len < perView * 2) {
                return [...testimonials, ...testimonials];
            }
            return testimonials;
        }
    },
    methods: {
        onPrev() {
            this.activeIndex--;
        },
        onNext() {
            this.activeIndex++;
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-testimonial.layout7 {
    position: relative;
    background-attachment: var(--background-attachment);
    .rma-pixel-img {
        display: block;
        width: 0;
        height: 0;
    }
    @include media-800 {
        background-attachment: initial;
    }
    .reviews-img-mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
    }
    .reviews-container {
        position: relative;
        z-index: 2;
    }
    .review-title {
        margin-bottom: 40px;
        color: var(--g-primary-color);
        @include media-800 {
            margin-bottom: 20px;
        }
    }
    .reviews-wrap {
        position: relative;

        .swiper {
            width: 100%;

            &.swiper-offset {
                .swiper-wrapper {
                    margin-left: calc((100px - 100%) * 0.2);
                }
            }

            .swiper-wrapper {
                align-items: center;
                @include media-800 {
                    align-items: flex-start;
                }
            }

            .swiper-slide {
                width: 550px;
                @media (min-width: 1920px) {
                    width: calc((100% - 100px) / 2.6);
                }
                @media (max-width: 1000px) {
                    width: calc((100% - 100px) / 2.6);
                }
                height: 350px;
                background: rgba(25, 25, 25, 1);

                &.swiper-slide-prev,
                &.swiper-slide-next + .swiper-slide {
                    opacity: 0.2;
                }

                @include media-800 {
                    width: 330px;
                }

                .item {
                    width: 100%;
                    height: 100%;
                    padding: 30px;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    @include media-800 {
                        padding: 20px;
                    }
                    .agent-info {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin-bottom: 20px;

                        .agent-avatar {
                            width: 80px;
                            height: 80px;
                            overflow: hidden;
                            border-radius: 50%;
                            margin-right: 20px;

                            .avatar,
                            .avatar-icon {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                vertical-align: middle;
                            }
                            .avatar-icon {
                                border-radius: 50%;
                                border: 1px solid var(--g-primary-color);
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                .iconfont {
                                    color: var(--g-primary-color);
                                    font-size: 24px;
                                }
                            }
                        }
                        .agent-name {
                            width: calc(100% - 100px);
                            .name {
                                color: var(--g-primary-color);
                                font-size: 16px;
                                font-weight: 700;
                                line-height: 24px;
                                width: 100%;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                                
                            }
                            .license {
                                margin-top: 8px;
                                color: var(--g-tip-color);
                                font-size: 12px;
                                line-height: 18px;
                                
                            }
                        }
                    }

                    .desc {
                        flex: 1;
                        margin-bottom: 24px;
                        color: var(--g-primary-color);
                        font-size: 18px;
                        line-height: 27px;
                        overflow-y: auto;
                        padding-right: 10px;
                        
                        @include media-800 {
                            font-size: 16px;
                            line-height: 24px;
                        }
                        &::-webkit-scrollbar {
                            width: 6px;
                        }
                        &::-webkit-scrollbar-track {
                            background: transparent;
                            border-radius: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            border-radius: 6px;
                            position: relative;
                            display: block;
                            width: 0;
                            height: 0;
                            cursor: pointer;
                            background-color: rgba(217, 217, 217, 1);
                            -webkit-transition: 0.3s background-color;
                            transition: 0.3s background-color;
                        }
                    }
                    .start-box {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        .icon-Star {
                            color: #ff973b;
                        }
                        .md-testimonial-logo {
                            height: 20px;
                            img {
                                height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                }
            }

            &.noMargin {
                margin-left: auto;
                justify-content: center;
                .swiper-wrapper {
                    justify-content: center;
                    transform: translate3d(0px, 0px, 0px) !important;
                    .swiper-slide {
                        &:last-child {
                            margin-right: 0 !important;
                        }
                        &.swiper-slide-prev {
                            opacity: 1;
                        }
                    }
                }
            }
        }

        &.mobile {
            padding-left: 15px;
            &.only {
                padding: 0 15px;
            }
            .swiper {
                margin-left: 0;
            }
        }

        .swiper-button-wrap {
            width: calc(100% + (100px - 100%) * 0.2 + 60px);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(calc(-50% + 18px), -50%);
            z-index: 10;
            display: flex;
            justify-content: space-between;
            align-items: center;

            @include media-800 {
                display: none;
            }

            .swiper-button {
                width: 50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: var(--g-btn-background);
                color: var(--g-btn-color);
                border-radius: 50%;
                cursor: pointer;
                i {
                    font-size: 20px;
                    line-height: 1;
                }
                &.navigation-disabled,
                &:disabled {
                    opacity: 0.3;
                    cursor: not-allowed;
                }
            }
        }
    }
    .swiper-button:not(.navigation-disabled) {
        @include color-button-hover(50%);
    }
}
</style>
